<script setup lang="ts">
// In-flow sidebar control. It stays inside the sidebar chrome instead of
// floating over the page edge, so the expand/collapse affordance is predictable
// without drawing attention away from the navigation.
import { useSidebarStore } from '@/stores/sidebar'

const sidebar = useSidebarStore()
</script>

<template>
  <button
    type="button"
    class="sidebar-collapse-toggle"
    :class="{ 'sidebar-collapse-toggle--collapsed': sidebar.isCollapsed }"
    :aria-label="sidebar.isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'"
    data-testid="sidebar-collapse-toggle"
    @click="sidebar.toggle"
  >
    <i :class="sidebar.isCollapsed ? 'pi pi-angle-right' : 'pi pi-angle-left'" aria-hidden="true" />
  </button>
</template>

<style scoped>
.sidebar-collapse-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: flex-end;
  width: 30px;
  height: 30px;
  padding: 0;
  background: transparent;
  border: 0;
  border-radius: var(--radius-md);
  color: var(--text-muted);
  cursor: pointer;
  font-size: var(--font-size-sm);
  line-height: 1;
  transition:
    background-color var(--duration-ui) var(--ease-default),
    color var(--duration-ui) var(--ease-default);
}

.sidebar-collapse-toggle:hover {
  background: var(--bg-card-hover);
  color: var(--text-primary);
}

.sidebar-collapse-toggle:focus-visible {
  outline: var(--focus-ring-width) solid var(--green-primary);
  outline-offset: var(--focus-ring-offset);
}

.sidebar-collapse-toggle--collapsed {
  align-self: center;
}
</style>
